import { defineMessages } from 'react-intl'

export default defineMessages({
  profileImage: {
    defaultMessage: 'Profile Image',
  },
})
